import {
  endOfMonth,
  endOfWeek,
  endOfYear,
  startOfMonth,
  startOfWeek,
  startOfYear,
  subDays,
  subMonths,
  subWeeks,
  subYears,
} from 'date-fns'
import { DateRange } from 'react-day-picker'

export enum PresetLabel {
  TODAY = 'Today',
  YESTERDAY = 'Yesterday',
  THIS_WEEK = 'This Week',
  LAST_WEEK = 'Last Week',
  THIS_MONTH = 'This Month',
  LAST_MONTH = 'Last Month',
  THIS_YEAR = 'This Year',
  LAST_YEAR = 'Last Year',
  ALL_TIME = 'All Time',
}

export interface Preset {
  label: PresetLabel
  provider: (date: Date) => DateRange
  isEnabled?: boolean
}

export const DATE_RANGE_PRESETS: Preset[] = [
  {
    label: PresetLabel.TODAY,
    provider: (today: Date) => {
      return { from: today, to: today }
    },
  },
  {
    label: PresetLabel.YESTERDAY,
    provider: (today: Date) => {
      return { from: subDays(today, 1), to: subDays(today, 1) }
    },
  },
  {
    label: PresetLabel.THIS_WEEK,
    provider: (today: Date) => {
      return {
        from: startOfWeek(today, { weekStartsOn: 1 }),
        to: endOfWeek(today, { weekStartsOn: 1 }),
      }
    },
  },
  {
    label: PresetLabel.LAST_WEEK,
    provider: (today: Date) => {
      return {
        from: startOfWeek(subWeeks(today, 1), { weekStartsOn: 1 }),
        to: endOfWeek(subWeeks(today, 1), { weekStartsOn: 1 }),
      }
    },
  },
  {
    label: PresetLabel.THIS_MONTH,
    provider: (today: Date) => {
      return {
        from: startOfMonth(today),
        to: endOfMonth(today),
      }
    },
  },
  {
    label: PresetLabel.LAST_MONTH,
    provider: (today: Date) => {
      return {
        from: startOfMonth(subMonths(today, 1)),
        to: endOfMonth(subMonths(today, 1)),
      }
    },
  },
  {
    label: PresetLabel.THIS_YEAR,
    provider: (today: Date) => {
      return {
        from: startOfYear(today),
        to: today,
      }
    },
  },
  {
    label: PresetLabel.LAST_YEAR,
    provider: (today: Date) => {
      return {
        from: startOfYear(subYears(today, 1)),
        to: endOfYear(subYears(today, 1)),
      }
    },
  },
]
